import React, { useContext } from "react";
import { Alert } from "reactstrap";
import { StateContext } from "../utils/context";
import { getModuleAccessDeniedMessage } from "../views/stripeSubscription/planUtils";

const ModuleAccessDeniedAlert = ({ fallbackMessage, module, className }) => {
  const { currentUser } = useContext(StateContext);

  return (
    <Alert color="danger" className={className}>
      {getModuleAccessDeniedMessage(currentUser, { fallbackMessage, module })}
    </Alert>
  );
};

export default ModuleAccessDeniedAlert;
